import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import Picture from '@/image/hotel/picture9.png';
import 'swiper/css';

interface ImageData {
  src: string;
  alt: string;
  text: string;
}

interface ReservationImageSliderProps {
  images: ImageData[];
}

export const ReservationImageSlider: React.FC<ReservationImageSliderProps> = ({
  images,
}) => {
  return (
    <div
      className="image-slider-container"
      style={{ maxWidth: '100%', overflow: 'hidden', maxHeight: '330px' }}
    >
      <Swiper
        spaceBetween={10}
        slidesPerView={1.1} // 1ページに1.1枚のスライドを表示
        centeredSlides={false}
        style={{ width: '100%' }}
      >
        {images.map((image, index) => (
          <SwiperSlide key={index}>
            <img
              src={image.src}
              alt={image.alt}
              className="w-full h-auto object-cover"
              style={{ height: '362px' }}
              onError={(e) => {
                e.currentTarget.src = Picture;
              }}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};
